// This file configures the initialization of Sentry on the client.
// The config you add here will be used whenever a users loads a page in their browser.
// https://docs.sentry.io/platforms/javascript/guides/nextjs/

;globalThis["_sentryRewritesTunnelPath"] = undefined;globalThis["SENTRY_RELEASE"] = {"id":"361f3f2f6558a1ab8bdda3a161647f2d171451a3"};globalThis["_sentryBasePath"] = undefined;globalThis["_sentryRewriteFramesAssetPrefixPath"] = "";import * as Sentry from "@sentry/nextjs";

Sentry.init({
  dsn: "https://0a60427c611c38fedfe6ed29b46e3eab@o4508324287217664.ingest.de.sentry.io/4508324288921680",
  enabled: process.env.NODE_ENV !== "development",

  // Add optional integrations for additional features
  integrations: [
    Sentry.replayIntegration(),
    //   Sentry.feedbackIntegration({
    //     colorScheme: "light",
    //     themeLight: {
    //       accentBackground: "hsl(142.1, 76.2%, 36.3%)",
    //     },
    //     enableScreenshot: true,
    //     showName: false,
    //     showEmail: false,
    //     showBranding: false,
    //     lang: "de",
    //     triggerLabel: "Feedback geben",
    //     buttonLabel: "Feedback senden",
    //     formTitle: "Feedback",
    //     submitButtonLabel: "Feedback absenden",
    //     cancelButtonLabel: "Abbrechen",
    //     confirmButtonLabel: "Bestätigen",
    //     addScreenshotButtonLabel: "Screenshot hinzufügen (optional)",
    //     removeScreenshotButtonLabel: "Screenshot entfernen",
    //     nameLabel: "Name",
    //     namePlaceholder: "Dein Name",
    //     emailLabel: "E-Mail",
    //     emailPlaceholder: "deine.email@beispiel.de",
    //     isRequiredLabel: "(erforderlich)",
    //     messageLabel: "Beschreibung",
    //     messagePlaceholder: "Was möchtest du uns mitteilen?",
    //     successMessageText: "Danke für dein Feedback!",
    //   }),
  ],

  // Define how likely traces are sampled. Adjust this value in production, or use tracesSampler for greater control.
  tracesSampleRate: 1,

  // Define how likely Replay events are sampled.
  // This sets the sample rate to be 10%. You may want this to be 100% while
  // in development and sample at a lower rate in production
  replaysSessionSampleRate: 0.1,

  // Define how likely Replay events are sampled when an error occurs.
  replaysOnErrorSampleRate: 1.0,

  // Setting this option to true will print useful information to the console while you're setting up Sentry.
  debug: false,
});
